module.exports = __webpack_public_path__ + "img/document.37d72e1e.svg";